import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const prefetchChunks = fetchers => WrappedComponent => {
  return class Prefetch extends Component {
    componentDidMount() {
      if (window.location.href.indexOf('ignorePrefetch') > -1) {
        return;
      }
      this.interval = setInterval(() => {
        if (document.readyState === 'complete') {
          fetchers.forEach(fetcher => fetcher());
          clearInterval(this.interval);
          this.interval = undefined;
        }
      }, 250);
    }
    componentWillUnmount() {
      if (this.interval) clearInterval(this.interval);
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  };
};
export default prefetchChunks;